// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23888%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27><polyline points=%276 9 12 15 18 9%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================
   ReelsSearchPage Styles
   Uses CSS variables from colors.css — flat surfaces, no gradients.
   Portrait (9:16) reel cards with a filter/sort toolbar.
   ====================== */

.reels-page-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  padding: 32px 36px;
  overflow-y: auto;
  box-sizing: border-box;
  background: var(--color-bg-root);
}

/* Header */
.reels-page-header-section {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.reels-page-header-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.reels-page-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--color-text-primary);
  margin: 0;
  letter-spacing: -0.3px;
}

.reels-page-subtitle {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin: 0;
  max-width: 560px;
}

.reels-page-updating {
  font-size: 12px;
  color: var(--color-text-secondary);
  align-self: center;
  white-space: nowrap;
}

/* Platform selector (segmented control with app icons) */
.reels-platform-selector {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  margin-bottom: 14px;
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  background: var(--color-bg-sidebar);
  flex-wrap: wrap;
}

.reels-platform-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 14px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease;
}

.reels-platform-btn:hover {
  color: var(--color-text-primary);
}

.reels-platform-btn--active {
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
}

/* Search */
.reels-page-search-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: min(480px, 100%);
  max-width: none;
  min-height: 46px;
  padding: 0;
  margin-bottom: 18px;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-sizing: border-box;
}

.reels-search-field {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
}

.reels-page-search-icon {
  position: absolute;
  left: 11px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--color-text-secondary);
  pointer-events: none;
}

.reels-search-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 46px;
  padding: 0 16px;
  border: 1px solid var(--color-text-primary);
  border-radius: 6px;
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.15s ease;
}

.reels-search-btn:hover {
  opacity: 0.88;
}

.reels-page-search {
  width: 100%;
  max-width: none;
  height: 46px;
  padding: 0 14px 0 40px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  font-size: 13px;
  font-family: inherit;
  box-sizing: border-box;
  transition: border-color 0.15s ease;
}

/* Override the shared sidebar search cap inside this compound control. */
.reels-page-search-row .reels-search-field .reels-page-search {
  width: 100%;
  max-width: none;
  height: 46px;
  padding: 0 14px 0 40px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
}

@media (max-width: 560px) {
  .reels-page-search-row {
    align-items: center;
  }

  .reels-search-btn {
    padding-inline: 16px;
  }
}

.reels-page-search:focus {
  outline: none;
}

.reels-page-search::placeholder {
  color: var(--color-text-secondary);
}

/* Filter bar */
.reels-filterbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 14px;
  margin-bottom: 16px;
  padding: 10px 14px;
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  background: var(--color-bg-sidebar);
}

.reels-filterbar-icon {
  color: var(--color-text-secondary);
  flex-shrink: 0;
}

.reels-filterbar-group {
  display: inline-flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.reels-filterbar-divider {
  width: 1px;
  align-self: stretch;
  min-height: 22px;
  background: var(--color-border-input);
}

.reels-filterbar .reels-reset {
  margin-left: auto;
}

.reels-control {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.reels-control-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--color-text-secondary);
}

.reels-select {
  padding: 6px 26px 6px 10px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 12.5px;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, opacity 0.15s ease;
  /* Custom caret */
  appearance: none;
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 8px center;
}

.reels-select:focus {
  outline: none;
  border-color: var(--color-text-secondary);
}

.reels-select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Filter chips */
.reels-chip-group {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.reels-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  font-size: 12.5px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;
}

.reels-chip:hover {
  border-color: var(--color-text-secondary);
  color: var(--color-text-primary);
}

.reels-chip--active {
  background: var(--color-text-primary);
  border-color: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
}

.reels-reset {
  padding: 6px 10px;
  border: none;
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 12.5px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.reels-reset:hover {
  color: var(--color-text-primary);
}

/* Result meta */
.reels-page-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.reels-page-meta-dim {
  font-weight: 400;
  color: var(--color-text-secondary);
}

/* Error */
.reels-page-error {
  padding: 10px 14px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: rgba(220, 38, 38, 0.08);
  color: #dc2626;
  font-size: 13px;
  margin-bottom: 16px;
}

/* Loading */
.reels-page-loading {
  color: var(--color-text-secondary);
  font-size: 13px;
  padding: 40px 0;
  text-align: center;
}

/* Empty state */
.reels-page-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 72px 24px;
  text-align: center;
  color: var(--color-text-secondary);
}

.reels-page-empty-icon {
  opacity: 0.3;
  margin-bottom: 4px;
}

.reels-page-empty p {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
}

/* Grid */
.reels-page-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 14px;
}

/* Reel card */
.reel-card {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  overflow: hidden;
  background: var(--color-bg-sidebar);
  cursor: pointer;
  text-decoration: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.reel-card:hover {
  border-color: var(--color-text-secondary);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
}

.reel-card:focus-visible {
  outline: 2px solid var(--color-text-secondary);
  outline-offset: 2px;
}

.reel-card-media {
  position: relative;
  width: 100%;
  aspect-ratio: 9 / 16;
  background: var(--color-bg-canvas-surface);
  overflow: hidden;
}

.reel-card-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.reel-card-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-secondary);
  opacity: 0.35;
}

.reel-card-external {
  position: absolute;
  top: 8px;
  right: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  text-decoration: none;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.reel-card:hover .reel-card-external {
  opacity: 1;
}

.reel-card-platform {
  position: absolute;
  top: 8px;
  left: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  backdrop-filter: blur(2px);
}

.reel-card-adtag {
  padding: 1px 6px;
  border-radius: 3px;
  border: 1px solid var(--color-border-input);
  color: var(--color-text-secondary);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.reel-card-views {
  position: absolute;
  bottom: 8px;
  left: 8px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 7px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
}

.reel-card-info {
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.reel-card-user {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.reel-card-verified {
  color: #3897f0;
  flex-shrink: 0;
}

.reel-card-caption {
  font-size: 11px;
  line-height: 1.4;
  color: var(--color-text-secondary);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.reel-card-stats {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 2px;
}

.reel-card-stats span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-secondary);
}

/* Load more */
.reels-loadmore-row {
  display: flex;
  justify-content: center;
  padding: 24px 0 8px;
}

.reels-loadmore-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 20px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.reels-loadmore-btn:hover:not(:disabled) {
  border-color: var(--color-text-secondary);
}

.reels-loadmore-btn:disabled {
  opacity: 0.6;
  cursor: default;
}

.reels-loadmore-row--loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--color-text-secondary);
  font-size: 13px;
  font-weight: 600;
}

.reels-spin {
  animation: reels-spin 0.8s linear infinite;
}

@keyframes reels-spin {
  to {
    transform: rotate(360deg);
  }
}

/* Skeleton cards */
.reel-skeleton {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  overflow: hidden;
  background: var(--color-bg-sidebar);
}

.reel-skeleton-media {
  width: 100%;
  aspect-ratio: 9 / 16;
}

.reel-skeleton-info {
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.reel-skeleton-line {
  height: 10px;
  border-radius: 4px;
}

.reel-skeleton-line--short {
  width: 55%;
}

.reel-skeleton-media,
.reel-skeleton-line {
  background-color: var(--color-bg-input);
  background-image: linear-gradient(
    90deg,
    transparent 0%,
    rgba(127, 127, 127, 0.14) 50%,
    transparent 100%
  );
  background-size: 220% 100%;
  background-repeat: no-repeat;
  animation: reels-shimmer 1.3s ease-in-out infinite;
}

@keyframes reels-shimmer {
  0% {
    background-position: 180% 0;
  }
  100% {
    background-position: -80% 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ReelsSearchPage.css"],"names":[],"mappings":"AAAA;;;;2BAI2B;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;EACrC,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,uDAAuD;EACvD,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,yDAAyQ;EACzQ,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,iCAAiC;EACjC,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,qBAAqB;EACrB,0DAA0D;AAC5D;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,uCAAuC;EACvC;;;;;GAKC;EACD,0BAA0B;EAC1B,4BAA4B;EAC5B,kDAAkD;AACpD;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["/* ======================\n   ReelsSearchPage Styles\n   Uses CSS variables from colors.css — flat surfaces, no gradients.\n   Portrait (9:16) reel cards with a filter/sort toolbar.\n   ====================== */\n\n.reels-page-content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  padding: 32px 36px;\n  overflow-y: auto;\n  box-sizing: border-box;\n  background: var(--color-bg-root);\n}\n\n/* Header */\n.reels-page-header-section {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.reels-page-header-left {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.reels-page-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  margin: 0;\n  letter-spacing: -0.3px;\n}\n\n.reels-page-subtitle {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  margin: 0;\n  max-width: 560px;\n}\n\n.reels-page-updating {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  align-self: center;\n  white-space: nowrap;\n}\n\n/* Platform selector (segmented control with app icons) */\n.reels-platform-selector {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px;\n  margin-bottom: 14px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  background: var(--color-bg-sidebar);\n  flex-wrap: wrap;\n}\n\n.reels-platform-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 14px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.12s ease, color 0.12s ease;\n}\n\n.reels-platform-btn:hover {\n  color: var(--color-text-primary);\n}\n\n.reels-platform-btn--active {\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n}\n\n/* Search */\n.reels-page-search-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: min(480px, 100%);\n  max-width: none;\n  min-height: 46px;\n  padding: 0;\n  margin-bottom: 18px;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  box-sizing: border-box;\n}\n\n.reels-search-field {\n  position: relative;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.reels-page-search-icon {\n  position: absolute;\n  left: 11px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--color-text-secondary);\n  pointer-events: none;\n}\n\n.reels-search-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 46px;\n  padding: 0 16px;\n  border: 1px solid var(--color-text-primary);\n  border-radius: 6px;\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: opacity 0.15s ease;\n}\n\n.reels-search-btn:hover {\n  opacity: 0.88;\n}\n\n.reels-page-search {\n  width: 100%;\n  max-width: none;\n  height: 46px;\n  padding: 0 14px 0 40px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color 0.15s ease;\n}\n\n/* Override the shared sidebar search cap inside this compound control. */\n.reels-page-search-row .reels-search-field .reels-page-search {\n  width: 100%;\n  max-width: none;\n  height: 46px;\n  padding: 0 14px 0 40px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n}\n\n@media (max-width: 560px) {\n  .reels-page-search-row {\n    align-items: center;\n  }\n\n  .reels-search-btn {\n    padding-inline: 16px;\n  }\n}\n\n.reels-page-search:focus {\n  outline: none;\n}\n\n.reels-page-search::placeholder {\n  color: var(--color-text-secondary);\n}\n\n/* Filter bar */\n.reels-filterbar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px 14px;\n  margin-bottom: 16px;\n  padding: 10px 14px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  background: var(--color-bg-sidebar);\n}\n\n.reels-filterbar-icon {\n  color: var(--color-text-secondary);\n  flex-shrink: 0;\n}\n\n.reels-filterbar-group {\n  display: inline-flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.reels-filterbar-divider {\n  width: 1px;\n  align-self: stretch;\n  min-height: 22px;\n  background: var(--color-border-input);\n}\n\n.reels-filterbar .reels-reset {\n  margin-left: auto;\n}\n\n.reels-control {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.reels-control-label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--color-text-secondary);\n}\n\n.reels-select {\n  padding: 6px 26px 6px 10px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 12.5px;\n  font-family: inherit;\n  cursor: pointer;\n  transition: border-color 0.15s ease, opacity 0.15s ease;\n  /* Custom caret */\n  appearance: none;\n  -webkit-appearance: none;\n  background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>\");\n  background-repeat: no-repeat;\n  background-position: right 8px center;\n}\n\n.reels-select:focus {\n  outline: none;\n  border-color: var(--color-text-secondary);\n}\n\n.reels-select:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Filter chips */\n.reels-chip-group {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.reels-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  font-size: 12.5px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;\n}\n\n.reels-chip:hover {\n  border-color: var(--color-text-secondary);\n  color: var(--color-text-primary);\n}\n\n.reels-chip--active {\n  background: var(--color-text-primary);\n  border-color: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n}\n\n.reels-reset {\n  padding: 6px 10px;\n  border: none;\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 12.5px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.reels-reset:hover {\n  color: var(--color-text-primary);\n}\n\n/* Result meta */\n.reels-page-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.reels-page-meta-dim {\n  font-weight: 400;\n  color: var(--color-text-secondary);\n}\n\n/* Error */\n.reels-page-error {\n  padding: 10px 14px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: rgba(220, 38, 38, 0.08);\n  color: #dc2626;\n  font-size: 13px;\n  margin-bottom: 16px;\n}\n\n/* Loading */\n.reels-page-loading {\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  padding: 40px 0;\n  text-align: center;\n}\n\n/* Empty state */\n.reels-page-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 72px 24px;\n  text-align: center;\n  color: var(--color-text-secondary);\n}\n\n.reels-page-empty-icon {\n  opacity: 0.3;\n  margin-bottom: 4px;\n}\n\n.reels-page-empty p {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* Grid */\n.reels-page-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 14px;\n}\n\n/* Reel card */\n.reel-card {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  overflow: hidden;\n  background: var(--color-bg-sidebar);\n  cursor: pointer;\n  text-decoration: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.reel-card:hover {\n  border-color: var(--color-text-secondary);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);\n}\n\n.reel-card:focus-visible {\n  outline: 2px solid var(--color-text-secondary);\n  outline-offset: 2px;\n}\n\n.reel-card-media {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 9 / 16;\n  background: var(--color-bg-canvas-surface);\n  overflow: hidden;\n}\n\n.reel-card-thumb {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.reel-card-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-text-secondary);\n  opacity: 0.35;\n}\n\n.reel-card-external {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n  background: rgba(0, 0, 0, 0.55);\n  color: #fff;\n  text-decoration: none;\n  opacity: 0;\n  transition: opacity 0.15s ease;\n}\n\n.reel-card:hover .reel-card-external {\n  opacity: 1;\n}\n\n.reel-card-platform {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  backdrop-filter: blur(2px);\n}\n\n.reel-card-adtag {\n  padding: 1px 6px;\n  border-radius: 3px;\n  border: 1px solid var(--color-border-input);\n  color: var(--color-text-secondary);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n}\n\n.reel-card-views {\n  position: absolute;\n  bottom: 8px;\n  left: 8px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 7px;\n  border-radius: 4px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.reel-card-info {\n  padding: 10px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.reel-card-user {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.reel-card-verified {\n  color: #3897f0;\n  flex-shrink: 0;\n}\n\n.reel-card-caption {\n  font-size: 11px;\n  line-height: 1.4;\n  color: var(--color-text-secondary);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.reel-card-stats {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 2px;\n}\n\n.reel-card-stats span {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n}\n\n/* Load more */\n.reels-loadmore-row {\n  display: flex;\n  justify-content: center;\n  padding: 24px 0 8px;\n}\n\n.reels-loadmore-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 20px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.reels-loadmore-btn:hover:not(:disabled) {\n  border-color: var(--color-text-secondary);\n}\n\n.reels-loadmore-btn:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.reels-loadmore-row--loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.reels-spin {\n  animation: reels-spin 0.8s linear infinite;\n}\n\n@keyframes reels-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Skeleton cards */\n.reel-skeleton {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  overflow: hidden;\n  background: var(--color-bg-sidebar);\n}\n\n.reel-skeleton-media {\n  width: 100%;\n  aspect-ratio: 9 / 16;\n}\n\n.reel-skeleton-info {\n  padding: 10px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.reel-skeleton-line {\n  height: 10px;\n  border-radius: 4px;\n}\n\n.reel-skeleton-line--short {\n  width: 55%;\n}\n\n.reel-skeleton-media,\n.reel-skeleton-line {\n  background-color: var(--color-bg-input);\n  background-image: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(127, 127, 127, 0.14) 50%,\n    transparent 100%\n  );\n  background-size: 220% 100%;\n  background-repeat: no-repeat;\n  animation: reels-shimmer 1.3s ease-in-out infinite;\n}\n\n@keyframes reels-shimmer {\n  0% {\n    background-position: 180% 0;\n  }\n  100% {\n    background-position: -80% 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
